import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@src/app/core/auth/auth.service';
import { APP_ROUTES } from '@src/app/core/constants/app-routes';
@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent {
    constructor(private authService: AuthService, private router: Router) { }
    
    public APP_ROUTES = APP_ROUTES;
    user: any = this.authService.getUserData();
    error: string = '';
    dropdownOpen: boolean = false;
    selectedOrg: any = this.user.linkedOrganizations?.find((org: any) => org.id === this.user.organizationId);
    organizations: any[] = this.user.linkedOrganizations || [];
    
    hasUIPermission(
        resourceKey: string,
        action: string
    ): boolean {
        return this.authService.checkPermission(resourceKey, action);
    }

    switchOrganization(id: number): void {
        this.authService.switchOrganization(id)
        .subscribe({
            next: () => {
                this.dropdownOpen = false;
                window.location.reload();
            },
            error: (res: any) => {
                this.error = (res?.error?.message) || 'An error occurred while switching organization. Please try again.';
            }
        });
    }

    toggleDropdown(): void {
        this.dropdownOpen = !this.dropdownOpen;
    }
}
